import React, { useCallback } from "react";
import {
  ControlledTextfield,
  IntegerTextField,
} from "../../../components/inputs";
import { Button, MenuItem } from "../../../components";

const FormPerfil = ({
  props,
  disabled,
  handleSubmit,
  perfil,
  voltarParaLista,
}) => {
  const handleClickNext = useCallback(
    (values) => {
      handleSubmit(values, perfil.id);
    },
    [handleSubmit, perfil]
  );

  return (
    <div className="card spacer">
      <div className="card-body">
        <span className="card-title color-brand">Perfil</span>
        <form onSubmit={props.handleSubmit(handleClickNext)}>
          <div className="row">
            <div className="col-12 col-md-12">
              <ControlledTextfield
                name={"tipo"}
                margin={"none"}
                disabled={disabled}
                formProps={props}
                uppercase={true}
                label={"Tipo"}
                inputProps={{ maxLength: 20 }}
              />
            </div>
          </div>
          <div className="row spacer">
            <div className="offset-md-2 col-md-4 col-12">
              <Button
                label="Voltar"
                onClick={voltarParaLista}
                loading={perfil.loading}
              />
            </div>
            <div className="col-md-4 col-12">
              <Button
                label="CONFIRMAR"
                type={"submit"}
                loading={perfil.loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormPerfil;
